import Addresses from 'components/RecurringOrderSuggestionsModal/Sections/Addresses/styled';

export default Addresses;
